export default "__VITE_ASSET__DuAQtVIL__"